
  export default {
    props: {
      modifiers: {
        type: Array,
        default: () => []
      },
      level: {
        type: Number,
        default: 1
      }
    },
    computed: {
      mobile() {
        return (this.$mq == 'sm' || this.$mq == 'md')
      }
    },
    methods: {
      truncate(str) {
        if (str.length >= 10) {
          return str.slice(0, 10).trim() + '...'
        } else {
          return str
        }
      },
      scrollTo(m) {
        setTimeout(() => {
          const toggle = document.getElementById('mod_'+m.id)
          const offset = document.querySelector('header').getBoundingClientRect().height-1
          if (this.mobile) {
            const top = toggle.getBoundingClientRect().top + window.scrollY - offset
            window.scrollTo({
              top: top,
              behavior: 'smooth'
            })
          } else {
            const options = document.querySelector('.options')
            const top = toggle.getBoundingClientRect().top + options.scrollTop - offset
            options.scrollTo({
              top: top,
              behavior: 'smooth'
            })
          }
        },250)
      },
      getModImage(metadata) {
        const url = metadata?.find(item => item.key === 'modifier-image')?.value
        if (!url) return false
        if (!url.includes('storyblok')) return url

        let imageUrl = url
          .replace(/pleinaircdn\.com\/storyblok\//g, 'storyblok.pleinaircdn.com/')
          .replace(/a\.storyblok\.com/g, 'storyblok.pleinaircdn.com')

        const isSvg = imageUrl.split('?')[0].toLowerCase().endsWith('.svg')
        if (!isSvg && !imageUrl.includes('/m/')) {
          imageUrl += '/m/360x0'
        }

        return imageUrl
      }
    }
  }
